import React from "react"

export default function Home() {
  return <div className="logo">binaryform</div>
}
